import { useEffect, useState } from 'react';
import { Grid, Typography, Box, List, ListItem, TextField, IconButton } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import NoObjectMessage from 'views/common/NoObjectMessage';
import { useNavigate, useParams } from 'react-router-dom';
import MainCard from 'ui-component/cards/MainCard';
import { AddCircleOutline } from '@mui/icons-material';
import { v4 as uuidv4 } from 'uuid';
import { useDispatch, useSelector } from 'react-redux';
import binIcon from 'assets/images/icons/Bin.svg';
import { ReactComponent as Tablerbracketicon } from '../../../assets/images/icons/Tablerbracketicon.svg';
import { ReactComponent as Tablerbracketreverceicon } from '../../../assets/images/icons/Tablerbracketreverceicon.svg';
import { ReactComponent as LeftArray } from '../../../assets/images/icons/leftArray.svg';
import { ReactComponent as RightArray } from '../../../assets/images/icons/rightArray.svg';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import CheckIcon from '@mui/icons-material/Check';
import MenuItem from '@mui/material/MenuItem';
import { RulesCondition, RulesObjects } from 'types/assignmentrules';
import { SET_RULES_DATA_CONDITION, SET_RULES_LEGALITY_VALUE } from 'store/slices/rules';

function CreatingLegality() {
    const [objects, setObjects] = useState<RulesCondition[]>([]);
    const [clickedLeftBracket, setClickedLeftBracket] = useState<any>([]);
    const [clickedRightBracket, setClickedRightBracket] = useState<any>([]);
    const [equation, setEquation] = useState<string>('');
    const [handlecheck, sethandleCheck] = useState<boolean>(false);
    const [buttonclicked, setButtonClicked] = useState<boolean>(false);
    const [selectedLeftBrackets, setSelectedLeftBrackets] = useState<any>([]);
    const [selectedRightBrackets, setSelectedRightBrackets] = useState<any>([]);
    const dispatch = useDispatch();
    const rulesParameterData = useSelector((state: any) => state.rules.data);

    const rulesCondiotionData = useSelector((state: any) => state.rules.rulesData);
    const rules_condition_data = useSelector((state: any) => state.rules.rule_condition_data);
    useEffect(() => {
        setObjects(rules_condition_data);
    }, [rules_condition_data]);

    useEffect(() => {
        rules_condition_data.forEach((item: any) => {
            if (Array.isArray(item?.condition)) {
                item?.condition.forEach((condition: any) => {
                    if (condition?.bracket === 'left') {
                        setSelectedLeftBrackets((prevLeftBracket: any) => [...prevLeftBracket, condition?.id]);
                    } else if (condition?.bracket === 'right') {
                        setSelectedRightBrackets((prevRightBracket: any) => [...prevRightBracket, condition?.id]);
                    }
                });
            }
        });
    }, [rules_condition_data]);
    const handleDeleteRules = () => {
        setObjects([]);
        sethandleCheck(false);
    };
    const handleDeleteObject = (deletedItemId: string) => {
        let data;
        let updatedObjects = objects.filter((item) => item.id !== deletedItemId);
        setObjects(updatedObjects);
        const index = objects.findIndex((item) => item.id === deletedItemId);

        if (index !== -1) {
            data = objects.filter((condition) => condition.id !== deletedItemId);

            updatedObjects = [...data];

            setObjects(updatedObjects);
            dispatch({
                type: SET_RULES_LEGALITY_VALUE,
                payload: updatedObjects
            });
        } else {
            console.log('Rule not found.');
        }
    };

    const handleAddObject = () => {
        const cond = [];
        const newConditionObject = {
            id: uuidv4(),
            bracket: '',
            operator: '',
            rule_unique_id: '',
            label: ''
        };
        cond.push(newConditionObject);

        const newObject = {
            id: uuidv4(),
            operator: objects.length == 0 ? '' : 'וגם',
            equation_label: '',
            condition: cond
        };
        const updatedObjects = [...objects, newObject];

        setObjects(updatedObjects);
    };
    const handleClickCheck = () => {
        sethandleCheck(true);

        let generatedString = '';
        let bracket = '';
        rulesCondiotionData.forEach((data: any) => {
            data?.condition?.forEach((item: any) => {
                const operatorMapping: Record<string, string> = {
                    '>': '<', // Use left-to-right mark
                    '<': '>', // Use left-to-right mark
                    '>=': '≤', // Right-to-left mark around the HTML entity
                    '<=': '≥ ' // Right-to-left mark around the HTML entity
                };

                const swappedLabel = item?.label.replace(/>=|<=|>|</g, (match: any) => operatorMapping[match]);

                if (item.bracket == 'left') {
                    bracket = '[';
                } else if (item.bracket == 'right') {
                    bracket = ']';
                } else {
                    bracket = '';
                }
                generatedString += `${swappedLabel}${!item?.operator ? '' : item?.operator}${bracket} `;
            });
        });
        generatedString = ` [${generatedString}]`;

        setEquation(generatedString);
    };
    const handleClickEdit = () => {
        sethandleCheck(false);
    };

    const handleAddCondition = (id: string) => {
        const newCondition: RulesObjects = {
            id: uuidv4(),
            bracket: '',
            operator: 'וגם',
            rule_unique_id: '',
            label: ''
        };

        const updatedObjects = objects.map((item: any) => {
            if (item.id === id) {
                return {
                    ...item,
                    condition: [...item.condition, newCondition]
                };
            }
            return item;
        });
        setObjects(updatedObjects);
    };
    const swapComparisonOperators = (label: string): string => {
        const operatorMapping: Record<string, string> = {
            '>': '<', // Use left-to-right mark
            '<': '>', // Use left-to-right mark
            '>=': '≤', // Right-to-left mark around the HTML entity
            '<=': '≥ ' // Right-to-left mark around the HTML entity
        };

        const swappedLabel = label.replace(/>=|<=|>|</g, (match) => operatorMapping[match]);
        return swappedLabel;
    };
    // const swappedEquationLabel = swapComparisonOperators(ru);

    const handleDelteCondtion = (id: any, ruleid: any) => {
        const index = objects.findIndex((item) => item.id === ruleid);

        if (index !== -1) {
            objects[index].condition = objects[index].condition.filter((condition) => condition.id !== id);

            const updatedObjects = [...objects];

            setObjects(updatedObjects);
        } else {
            console.log('Rule not found.');
        }
    };
    // const renderStringWithIcon = () => {
    //     const stringWithIcon = equation.split(/(או|OR|וגם)/).map((part, index) => {
    //         if (part === 'או') {
    //             return (
    //                 <span key={index} style={{ color: 'red' }}>
    //                     {part}
    //                 </span>
    //             );
    //         }
    //         if (part === 'וגם') {
    //             return (
    //                 <span key={index} style={{ color: 'green' }}>
    //                     {part}
    //                 </span>
    //             );
    //         }
    //         if (part === ']') {
    //             return (
    //                 <IconButton aria-label="clear" color="inherit">
    //                     <RightArray style={{ height: '18px', width: '5px' }} />
    //                 </IconButton>
    //             );
    //         }
    //         if (part === '[') {
    //             return (
    //                 <IconButton aria-label="clear" color="inherit">
    //                     <LeftArray style={{ height: '18px', width: '5px' }} />
    //                 </IconButton>
    //             );
    //         }
    //         return part;
    //     });

    //     return stringWithIcon;
    //     sethandleCheck(true);
    // };
    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                    <MainCard
                        title={
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                }}
                            >
                                <Typography sx={{ fontWeight: 400, fontSize: '14px', lineHeight: '20px', color: '#000000' }}>
                                    <FormattedMessage id="creating-legality" />
                                </Typography>
                                <Typography
                                    sx={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#7A49B9', cursor: 'pointer' }}
                                    onClick={handleAddObject}
                                >
                                    <AddCircleOutline
                                        onClick={handleAddObject}
                                        fontSize="small"
                                        sx={{ position: 'relative', color: '#7A49B9', cursor: 'pointer' }}
                                    />
                                    <FormattedMessage id="adding-legality" />
                                </Typography>
                            </Box>
                        }
                    >
                        {objects.length === 0 ? (
                            <>
                                <NoObjectMessage informativeMessage="no-object-message" actionMessage="no-object-action-message" />
                            </>
                        ) : (
                            <>
                                <List
                                    sx={{
                                        minHeight: 100
                                    }}
                                >
                                    {handlecheck == true ? (
                                        <>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    gap: '10px',
                                                    justifyContent: 'center',
                                                    alignItems: 'center'
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        padding: '20px 50px',
                                                        borderRadius: '15px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        backgroundColor: '#F7F4FB',
                                                        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)'
                                                    }}
                                                >
                                                    {/* <IconButton aria-label="clear" color="inherit">
                                                        <RightArray />
                                                    </IconButton>
                                                    <IconButton aria-label="clear" color="inherit">
                                                        <RightArray style={{ height: '18px', width: '5px' }} />
                                                    </IconButton> */}
                                                    <Typography>{equation}</Typography>
                                                    {/* <Typography
                                                        sx={{
                                                            fontWeight: 400,
                                                            fontSize: '14px',
                                                            color: '#7A49B9',
                                                            marginLeft: '20px',
                                                            marginRight: '20px'
                                                        }}
                                                    >
                                                        וגם
                                                    </Typography>
                                                    <Typography>זמינות 50</Typography>

                                                    <IconButton aria-label="clear" color="inherit">
                                                        <LeftArray style={{ height: '18px', width: '5px' }} />
                                                    </IconButton>
                                                    <Typography
                                                        sx={{ fontWeight: 400, fontSize: '14px', color: '#7A49B9', marginRight: '20px' }}
                                                    >
                                                        או
                                                    </Typography>
                                                    <Typography>מבחן פתיחה כמותי 30%</Typography>
                                                    <IconButton aria-label="clear" color="inherit" sx={{ direction: 'revert' }}>
                                                        <LeftArray />
                                                    </IconButton> */}
                                                </Box>
                                                <Box
                                                    sx={{
                                                        display: 'flex'
                                                    }}
                                                >
                                                    <EditOutlinedIcon
                                                        sx={{ color: '#7A49B9', height: '24px', width: '24px', cursor: 'pointer' }}
                                                        onClick={handleClickEdit}
                                                    />
                                                </Box>
                                                <IconButton aria-label="clear" color="inherit" onClick={handleDeleteRules}>
                                                    <img src={binIcon} alt="delete icon" style={{ height: '24px', width: '24px' }} />
                                                </IconButton>
                                            </Box>
                                        </>
                                    ) : (
                                        <>
                                            {objects?.map((item: any, objectIndex: number) => (
                                                <Box key={objectIndex}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                        {item?.operator && (
                                                            <Box sx={{ marginBottom: '20px' }}>
                                                                <TextField
                                                                    select
                                                                    value={item?.operator}
                                                                    variant="outlined"
                                                                    size="small"
                                                                    // label={<FormattedMessage id="choice" />}
                                                                    onChange={(e) => {
                                                                        const updatedItems = [...objects];

                                                                        const itemindex = updatedItems.findIndex(
                                                                            (data: any) => data.id == item.id
                                                                        );

                                                                        updatedItems[itemindex].operator = e.target.value;
                                                                        dispatch({
                                                                            type: SET_RULES_LEGALITY_VALUE,
                                                                            payload: updatedItems
                                                                        });
                                                                        setObjects(updatedItems);
                                                                    }}
                                                                    sx={{ width: '72px', height: '30px' }}
                                                                >
                                                                    <MenuItem value="AND">וגם</MenuItem>
                                                                    <MenuItem value="OR">או</MenuItem>
                                                                </TextField>
                                                            </Box>
                                                        )}
                                                    </Box>
                                                    <ListItem alignItems="center" sx={{ display: 'block' }}>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                gap: '30px',
                                                                justifyContent: 'center',
                                                                alignItems: 'center'
                                                            }}
                                                        >
                                                            <Box
                                                                sx={{
                                                                    padding: '20px 50px',
                                                                    borderRadius: '15px',
                                                                    display: 'flex',
                                                                    gap: '10px',
                                                                    alignItems: 'center',
                                                                    // justifyContent: 'center',
                                                                    backgroundColor: '#F7F4FB',
                                                                    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
                                                                    maxWidth: '100%',
                                                                    overflow: 'auto',
                                                                    transform: 'scaleX(1)',
                                                                    '::-webkit-scrollbar': {
                                                                        width: '0.75rem',
                                                                        height: '0.75rem'
                                                                    },
                                                                    '::-webkit-scrollbar-track': {
                                                                        backgroundColor: '#E4DBF0',
                                                                        borderRadius: '0.625rem'
                                                                    },
                                                                    '::-webkit-scrollbar-button:vertical:start:decrement,::-webkit-scrollbar-button:vertical:end:increment':
                                                                        {
                                                                            display: 'none'
                                                                        },
                                                                    '::-webkit-scrollbar-thumb': {
                                                                        backgroundColor: '#7A49B9',
                                                                        borderRadius: '0.625rem'
                                                                    }
                                                                }}
                                                            >
                                                                <IconButton
                                                                    aria-label="clear"
                                                                    color="inherit"
                                                                    sx={{
                                                                        padding: '5px 6px 5px 6px',
                                                                        borderRadius: '3px',
                                                                        gap: '10px',
                                                                        backgroundColor: '#C8B7E1',
                                                                        '&:hover': {
                                                                            backgroundColor: '#C8B7E1'
                                                                        }
                                                                    }}
                                                                >
                                                                    <Tablerbracketreverceicon />
                                                                </IconButton>
                                                                {item?.condition.map((conditionObj: any, index: number) => (
                                                                    <>
                                                                        <Box
                                                                            sx={{
                                                                                display: 'flex',
                                                                                gap: '16px',
                                                                                justifyContent: 'center',
                                                                                alignItems: 'baseline'
                                                                            }}
                                                                        >
                                                                            {conditionObj.operator && (
                                                                                <TextField
                                                                                    select
                                                                                    value={conditionObj.operator}
                                                                                    variant="outlined"
                                                                                    size="small"
                                                                                    // label={<FormattedMessage id="choice" />}
                                                                                    sx={{ width: '72px', height: '30px' }}
                                                                                    onChange={(e) => {
                                                                                        const updatedItems = [...objects];

                                                                                        const itemindex = updatedItems.findIndex(
                                                                                            (data: any) => data.id == item.id
                                                                                        );

                                                                                        const asssignmentIndex = updatedItems[
                                                                                            itemindex
                                                                                        ].condition.findIndex(
                                                                                            (data: any) => data.id == conditionObj.id
                                                                                        );

                                                                                        updatedItems[itemindex].condition[
                                                                                            asssignmentIndex
                                                                                        ].operator = e.target.value;
                                                                                        dispatch({
                                                                                            type: SET_RULES_LEGALITY_VALUE,
                                                                                            payload: updatedItems
                                                                                        });
                                                                                        setObjects(updatedItems);
                                                                                    }}
                                                                                >
                                                                                    <MenuItem value="AND">וגם</MenuItem>
                                                                                    <MenuItem value="OR">או</MenuItem>
                                                                                </TextField>
                                                                            )}
                                                                            <Box sx={{ display: 'block' }}>
                                                                                <Box
                                                                                    sx={{
                                                                                        display: 'flex',
                                                                                        gap: '10px',
                                                                                        justifyContent: 'center'
                                                                                    }}
                                                                                >
                                                                                    <TextField
                                                                                        select
                                                                                        key={index}
                                                                                        value={conditionObj.rule_unique_id}
                                                                                        variant="outlined"
                                                                                        label={
                                                                                            <FormattedMessage id="Selection-from-the-selected-parameter" />
                                                                                        }
                                                                                        onChange={(e) => {
                                                                                            // eslint-disable-next-line
                                                                                            // debugger;
                                                                                            const updatedItems = [...objects];
                                                                                            const itemindex = updatedItems.findIndex(
                                                                                                (data: any) => data.id == item.id
                                                                                            );
                                                                                            const asssignmentIndex = updatedItems[
                                                                                                itemindex
                                                                                            ].condition.findIndex(
                                                                                                (data: any) => data.id == conditionObj.id
                                                                                            );
                                                                                            updatedItems[itemindex].condition[
                                                                                                asssignmentIndex
                                                                                            ].rule_unique_id = e.target.value;
                                                                                            const selectedName = rulesParameterData
                                                                                                .filter(
                                                                                                    (o: any) =>
                                                                                                        o.unique_id === e.target.value
                                                                                                )
                                                                                                .map(
                                                                                                    (filteredObject: any) =>
                                                                                                        filteredObject.equation_label
                                                                                                );
                                                                                            conditionObj.label = selectedName[0];
                                                                                            // updatedItems.rule_unique_id =
                                                                                            //     e.target.value;
                                                                                            dispatch({
                                                                                                type: SET_RULES_LEGALITY_VALUE,
                                                                                                payload: updatedItems
                                                                                            });
                                                                                            setObjects(updatedItems);
                                                                                        }}
                                                                                        // Update the state and dispatch the action only if there's a change

                                                                                        // Update the state and dispatch the action only if there's a change

                                                                                        sx={{ width: '230px', height: '30px' }}
                                                                                    >
                                                                                        {rulesParameterData?.map(
                                                                                            (data: any, indexData: number) => (
                                                                                                <MenuItem
                                                                                                    value={data?.unique_id}
                                                                                                    key={indexData}
                                                                                                >
                                                                                                    {swapComparisonOperators(
                                                                                                        data?.equation_label
                                                                                                    )}
                                                                                                </MenuItem>
                                                                                            )
                                                                                        )}
                                                                                    </TextField>
                                                                                </Box>
                                                                                <Box
                                                                                    sx={{
                                                                                        display: 'flex',
                                                                                        gap: '10px',
                                                                                        justifyContent: 'center',
                                                                                        alignItems: 'center',
                                                                                        marginTop: '15px'
                                                                                    }}
                                                                                >
                                                                                    <IconButton
                                                                                        aria-label="clear"
                                                                                        color="inherit"
                                                                                        // onClick={(e: any) => {
                                                                                        //     handleLeftBracketClick(conditionObj.id);
                                                                                        // }}
                                                                                        sx={{
                                                                                            padding: '5px 6px 5px 6px',
                                                                                            borderRadius: '3px',
                                                                                            backgroundColor: selectedLeftBrackets.includes(
                                                                                                conditionObj.id
                                                                                            )
                                                                                                ? '#7A49B9'
                                                                                                : '#C8B7E1',
                                                                                            '&:hover': {
                                                                                                backgroundColor:
                                                                                                    selectedLeftBrackets.includes(
                                                                                                        conditionObj.id
                                                                                                    )
                                                                                                        ? '#7A49B9'
                                                                                                        : '#C8B7E1'
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        <Tablerbracketreverceicon
                                                                                            onClick={() => {
                                                                                                const isSelected =
                                                                                                    selectedLeftBrackets.includes(
                                                                                                        conditionObj.id
                                                                                                    );
                                                                                                if (isSelected) {
                                                                                                    setSelectedLeftBrackets(
                                                                                                        (prevSelected: any) =>
                                                                                                            prevSelected.filter(
                                                                                                                (value: any) =>
                                                                                                                    value !==
                                                                                                                    conditionObj.id
                                                                                                            )
                                                                                                    );
                                                                                                } else {
                                                                                                    setSelectedLeftBrackets(
                                                                                                        (prevSelected: any) => [
                                                                                                            ...prevSelected,
                                                                                                            conditionObj.id
                                                                                                        ]
                                                                                                    );
                                                                                                }
                                                                                                const updatedItems = [...objects];
                                                                                                const itemindex = updatedItems.findIndex(
                                                                                                    (data: any) => data.id == item.id
                                                                                                );

                                                                                                const asssignmentIndex = updatedItems[
                                                                                                    itemindex
                                                                                                ].condition.findIndex(
                                                                                                    (data: any) =>
                                                                                                        data.id == conditionObj.id
                                                                                                );

                                                                                                updatedItems[itemindex].condition[
                                                                                                    asssignmentIndex
                                                                                                ].bracket = isSelected ? '' : 'left';
                                                                                                dispatch({
                                                                                                    type: SET_RULES_LEGALITY_VALUE,
                                                                                                    payload: updatedItems
                                                                                                });
                                                                                                setClickedLeftBracket(
                                                                                                    (prevSelectedValues: any) => [
                                                                                                        ...prevSelectedValues,
                                                                                                        conditionObj.id
                                                                                                    ]
                                                                                                );
                                                                                                setClickedRightBracket(
                                                                                                    (prevSelectedValues: any) =>
                                                                                                        prevSelectedValues.filter(
                                                                                                            (value: any) =>
                                                                                                                value !== conditionObj.id
                                                                                                        )
                                                                                                );

                                                                                                setObjects(updatedItems);
                                                                                                // if (buttonclicked === true) {
                                                                                                //     setButtonClicked(false);
                                                                                                // }
                                                                                            }}
                                                                                            style={{ height: '15px', width: '14px' }}
                                                                                        />
                                                                                    </IconButton>
                                                                                    <IconButton
                                                                                        aria-label="clear"
                                                                                        color="inherit"
                                                                                        // onClick={() =>
                                                                                        //     handleRightBracketClick(conditionObj.id)
                                                                                        // }
                                                                                        sx={{
                                                                                            padding: '5px 6px 5px 6px',
                                                                                            borderRadius: '3px',
                                                                                            backgroundColor: selectedRightBrackets.includes(
                                                                                                conditionObj.id
                                                                                            )
                                                                                                ? '#7A49B9'
                                                                                                : '#C8B7E1',
                                                                                            '&:hover': {
                                                                                                backgroundColor:
                                                                                                    selectedRightBrackets.includes(
                                                                                                        conditionObj.id
                                                                                                    )
                                                                                                        ? '#7A49B9'
                                                                                                        : '#C8B7E1'
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        <Tablerbracketicon
                                                                                            onClick={() => {
                                                                                                const isSelected =
                                                                                                    selectedRightBrackets.includes(
                                                                                                        conditionObj.id
                                                                                                    );
                                                                                                if (isSelected) {
                                                                                                    setSelectedRightBrackets(
                                                                                                        (prevSelected: any) =>
                                                                                                            prevSelected.filter(
                                                                                                                (value: any) =>
                                                                                                                    value !==
                                                                                                                    conditionObj.id
                                                                                                            )
                                                                                                    );
                                                                                                } else {
                                                                                                    setSelectedRightBrackets(
                                                                                                        (prevSelected: any) => [
                                                                                                            ...prevSelected,
                                                                                                            conditionObj.id
                                                                                                        ]
                                                                                                    );
                                                                                                }
                                                                                                const updatedItems = [...objects];
                                                                                                const itemindex = updatedItems.findIndex(
                                                                                                    (data: any) => data.id == item.id
                                                                                                );

                                                                                                const asssignmentIndex = updatedItems[
                                                                                                    itemindex
                                                                                                ].condition.findIndex(
                                                                                                    (data: any) =>
                                                                                                        data.id == conditionObj.id
                                                                                                );

                                                                                                updatedItems[itemindex].condition[
                                                                                                    asssignmentIndex
                                                                                                ].bracket = isSelected ? '' : 'right';
                                                                                                dispatch({
                                                                                                    type: SET_RULES_LEGALITY_VALUE,
                                                                                                    payload: updatedItems
                                                                                                });

                                                                                                setObjects(updatedItems);
                                                                                                setClickedRightBracket(
                                                                                                    (prevSelectedValues: any) => [
                                                                                                        ...prevSelectedValues,
                                                                                                        conditionObj.id
                                                                                                    ]
                                                                                                );
                                                                                                setClickedLeftBracket(
                                                                                                    (prevSelectedValues: any) =>
                                                                                                        prevSelectedValues.filter(
                                                                                                            (value: any) =>
                                                                                                                value !== conditionObj.id
                                                                                                        )
                                                                                                );
                                                                                            }}
                                                                                            style={{ height: '15px', width: '14px' }}
                                                                                        />
                                                                                    </IconButton>
                                                                                    <IconButton
                                                                                        aria-label="clear"
                                                                                        color="inherit"
                                                                                        disabled={index == 0}
                                                                                    >
                                                                                        <IconButton
                                                                                            aria-label="clear"
                                                                                            color="inherit"
                                                                                            onClick={() =>
                                                                                                handleDelteCondtion(
                                                                                                    conditionObj?.id,
                                                                                                    item?.id
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            <img
                                                                                                src={binIcon}
                                                                                                alt="delete icon"
                                                                                                style={{ height: '18px', width: '20px' }}
                                                                                            />
                                                                                        </IconButton>
                                                                                    </IconButton>
                                                                                </Box>
                                                                            </Box>
                                                                        </Box>
                                                                    </>
                                                                ))}

                                                                <IconButton
                                                                    aria-label="clear"
                                                                    color="inherit"
                                                                    sx={{
                                                                        padding: '5px 6px 5px 6px',
                                                                        borderRadius: '3px',
                                                                        gap: '10px',
                                                                        backgroundColor: '#C8B7E1',
                                                                        '&:hover': {
                                                                            backgroundColor: '#C8B7E1'
                                                                        }
                                                                    }}
                                                                >
                                                                    <Tablerbracketicon />
                                                                </IconButton>
                                                                <IconButton aria-label="clear" color="inherit">
                                                                    <AddCircleOutline
                                                                        sx={{ color: '#7A49B9', height: '13px', width: '13px' }}
                                                                        onClick={() => handleAddCondition(item?.id)}
                                                                    />
                                                                </IconButton>
                                                            </Box>

                                                            <Box
                                                                sx={{
                                                                    display: 'flex',
                                                                    gap: '10px',
                                                                    justifyContent: 'center',
                                                                    alignItems: 'center'
                                                                }}
                                                            >
                                                                <Box
                                                                    sx={{
                                                                        display: 'flex',
                                                                        border: '1px solid #00C853',
                                                                        borderRadius: '3px'
                                                                    }}
                                                                >
                                                                    <CheckIcon
                                                                        sx={{
                                                                            color: '#00C853',
                                                                            height: '22px',
                                                                            width: '22px',
                                                                            cursor: 'pointer',
                                                                            transition: 'color 0.3s',
                                                                            '&:hover': {
                                                                                backgroundColor: '#00C853',
                                                                                color: '#FFFFFF',
                                                                                height: '22px',
                                                                                width: '22px'
                                                                            }
                                                                        }}
                                                                        onClick={handleClickCheck}
                                                                    />
                                                                </Box>
                                                                <IconButton
                                                                    aria-label="clear"
                                                                    color="inherit"
                                                                    onClick={() => handleDeleteObject(item.id)}
                                                                >
                                                                    <img
                                                                        src={binIcon}
                                                                        alt="delete icon"
                                                                        style={{ height: '24px', width: '24px' }}
                                                                    />
                                                                </IconButton>
                                                            </Box>
                                                        </Box>
                                                    </ListItem>
                                                </Box>
                                            ))}
                                        </>
                                    )}
                                </List>
                            </>
                        )}
                    </MainCard>
                </Grid>
            </Grid>
        </>
    );
}

export default CreatingLegality;
